import { Route, Routes } from 'react-router-dom'

import StockDeductionDetailPage from './components/StockDeduction/StockDeductionDetailPage'
import OrderTiktokListPage from './Features/OrderTiktokList'
import ShopeeSalesReportPage from './Features/ShopeeSalesReport'
import TiktokSalesReportPage from './Features/TikTokSalesReport'
import TiktokSaleOrderDetailPage from './Features/TikTokSalesReport/OrderDetailPage'

const OrdersPlatformsPage = () => {
  return (
    <Routes>
      <Route path="/tiktok" element={<OrderTiktokListPage />} />
      <Route path="/tiktok/sales-report" element={<TiktokSalesReportPage />} />
      <Route
        path="/tiktok/sales-report/order/:orderId"
        element={<TiktokSaleOrderDetailPage />}
      />
      {/* หน้าเดียวใช้ได้ทุก marketplace — platform มาทาง query string */}
      <Route
        path="/tiktok/sales-report/stock/:date"
        element={<StockDeductionDetailPage />}
      />
      <Route path="/shopee/sales-report" element={<ShopeeSalesReportPage />} />
      <Route
        path="/shopee/sales-report/stock/:date"
        element={<StockDeductionDetailPage />}
      />
    </Routes>
  )
}

export default OrdersPlatformsPage
